'use client';
import useSWR from 'swr';
import { fetcher } from '@/shared/api/fetcher';

export function useLanguage() {
  const { data, error, isLoading } = useSWR('/languages', fetcher);

  return {
    langauges: data,
    isError: error,
    isLoading,
  };
}
